const gQueue = [];
let gIsPlaying = false;

export default {
  addToQueue,
  playQueue,
};

function addToQueue(action, afterAction) {
  const queueItem = _createQueueItem(action, afterAction);
  gQueue.push(queueItem);
}

async function playQueue() {
  if (gIsPlaying) return;
  while (gQueue.length) {
    gIsPlaying = true;
    const item = gQueue.shift();
    const { action, afterAction } = item;
    try {
      const res = await action.func(...action.params);
      if (afterAction) {
        _handleAfterAction(res, afterAction);
      }
    } catch (err) {
      console.log('QUEUE ERROR', err);
    }
  }
  gIsPlaying = false;
}

function _handleAfterAction(res, afterAction) {
  const { func, params } = afterAction;
  params.forEach((param) => {
    for (let key in param) {
      let currVal = param[key];
      if (currVal === 'res') param[key] = res;
    }
  });
  func(...params);
}
function _createQueueItem(action, afterAction) {
  return {
    action,
    afterAction,
  };
}
